import { DELETE_URL_PATHS } from 'src/common/consts/ApiUrlPaths';

export const DELETE_URL_BY_PRODUCT = {
	mfa: DELETE_URL_PATHS.MFA,
	msdk: DELETE_URL_PATHS.MSDK,
	wfa: DELETE_URL_PATHS.WFA,
	wsdk: DELETE_URL_PATHS.WSDK
} as const;
